import { useQuery } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { getPartners } from 'modules/settings/api';

export const useQueryPartners = () => {
  const {
    data: partners,
    isLoading: isLoadingPartners,
    isError: isErrorPartners,
  } = useQuery([QUERY_KEYS.SETTINGS_PARTNERS], getPartners, {
    staleTime: 5 * 60 * 1000,
    keepPreviousData: true,
  });

  return { partners, isLoadingPartners, isErrorPartners };
};
